import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "./chartTemplate";


/* 
dc-js chart template 
 */
const anualTempChartFunc = (divRef, ndx) => {
    // dimension by  county
    const dimension = ndx.dimension((d) => d.baseTbCode);
    // compute or return total anuall tempreature  for every  county
    var grp = dimension.group().reduceSum(function (d) {
        return d.annual_Temperature;
    });
    // custom reducer to  compute the averages
    const anualPrepgroup = dimension.groupAll().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.annual_Temperature;
            p.avg = p.tot / 47
            p.actual = v.annual_Temperature
            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.annual_Temperature;
            p.avg = p.count ? p.tot / 47 : 0; // hard code number of counties due to dublicates in data
            p.actual = v.annual_Temperature
            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg: 0, actual: 0 };
        }
    );
    const all = ndx.groupAll().reduceSum((d) => d.annual_Temperature).value();
    let total_anual_prep = all

    //  create the dc instance
    const projects = dc.numberDisplay(divRef);

    projects

        .dimension(dimension)

        .formatNumber(d3.format(",.2f"))

        .group(anualPrepgroup)

        .transitionDuration(0)

        // calculate values depending on the value being returned by the filter
        .on("pretransition  ", function (chart) {
            chart.valueAccessor((d) => {
               // round of the values for easy  comparison
                let a =Math.floor(d.avg * 47)
              
                let b =Math.floor(total_anual_prep)
                let record_count = d.count / 24 // the counties rows are dublicated 24 time 
                
                if (a < b && record_count == 1) {
                  // return the current row
                    return d.avg * 47
                } else if (a < b && record_count > 1) {
                    return (d.avg * 47) / record_count
                } else if (a == b) { 
                    
                    return b / 47
                    //console.log("second if statement: " + a)
                }
            });

        })

        .valueAccessor((d) => {
            return d.avg; // return the average rainfall for all the counties.
        })



    // return the dc chart  object
    return projects;

};

export const AnnualTempChart = (props) => (
    // pass the chart object to the Chart template for rendering
    <ChartTemplate chartFunction={anualTempChartFunc} />
);


//const anTempChartFunc = (divRef, ndx) => {
//  const dimension = ndx.dimension((d) => d.baseTbCode);
//  //const grp = dimension.groupAll().reduceSum((d) => d.annual_Temperature);

//    // custom reduce
//    const anualTempreature = dimension.groupAll().reduce(
//    /* callback for when data is added to the current filter results */
//        function (p, v) {
//            ++p.count;
//            p.tot += v;
//            p.avg = p.tot / 47
//            p.actual = v.annual_Precipitation
           
//            return p;
//        },
//        function (p, v) {
//        /* callback for when data is removed from the current filter results */
//            --p.count;
//            p.tot -= v.annual_Temperature;
//            // hard code number of counties due to dublicates in data
//            // if you unique records : use counts
//            p.avg = p.count ? p.tot / 47 : 0;  // ensure theres a row inside in the bin
            
//            return p;
//        },
//    /* initialize p */
//        function () {
//            return { count: 0, tot: 0, avg: 0};
//        }
//    );
//    /* compute totals for all  the counties*/
//    const all = ndx.groupAll().reduceSum((d) => d.annual_Temperature).value();
//    let total_anual_temp = all
//   /* console.log(total_anual_temp)*/
///* create anual tempreature chart*/
//  const projects = dc.numberDisplay(divRef);
//    projects
//        .dimension(dimension)
//        .group(anualTempreature)
//      .transitionDuration(0)
//      .formatNumber(d3.format(".2f"))
//      // calculate values depending on the value being returned by the filter
//      .on("pretransition  ", function (chart) {
//          chart.valueAccessor((d) => {
//              //Math.floor(d.avg * 47)
//              //Math.floor
//              let a = (d.avg * 47).toFixed(2)
//              let b = (total_anual_temp).toFixed(2)
//              let record_count = d.count / 24 // the counties rows are dublicated 24 time 
//              if (a < b) {
//                  return a
//              } else if (a < b && record_count > 1) {
//                  return a / record_count
//              } else if (a == b) {
//                  console.log("second if temp : " + a)
//                  return a / 47
//              }
//          });
//      })
//      .valueAccessor((d) => {
          
//          return d.avg;
//      })
//  return projects;
//};

//export const AnnualTempChart = (props) => (
//  <ChartTemplate chartFunction={anTempChartFunc} />
//);
